import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ImageModule } from '@df/module-image/image.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent } from '@icms/core/content/component/icms-component.decorator';
import { ICmsContent } from '@icms/core/content/component/icms-content.decorator';
import { NICmsContentComponent } from '@icms/core/content/interfaces/icms-content-component.interfaces';
import { NICmsContentField } from '@icms/core/content/interfaces/icms-content-field.interfaces';
import { ButtonStyleComponent } from '../../../common/buttons/button-style/button-style.component';
import { TextBoxComponent } from '../../../common/text-box/text-box.component';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { DfModuleImageModule } from '@df/module-image/df-module-image.module';

interface IPageComponentImagesData extends NICmsContentComponent.IData {
    images: IImages[];
}

interface IImages {
    image: string;
    imageCaption: string;
}

@ICmsComponent<CmsBlogComponentImagesComponent>({
    id: 'cms-blog-images',
    name: 'Blog / One, Two or Three Images',
    tags: ['Blog'],
    onDemandOnly: true,
    fields: [
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'images',
            title: 'Images',
            minSize: 1,
            maxSize: 3,
            defaultSize: 3,
            fields: [
                {
                    type: NICmsContentField.EFieldType.image,
                    key: 'image',
                    title: 'Image',
                    required: true
                },
                {
                    type: NICmsContentField.EFieldType.text,
                    key: 'imageCaption',
                    title: 'Image Caption',
                    required: true
                }
            ]
        }
    ]
})
@Component({
    standalone: true,
    imports: [DfModuleImageModule, ICmsClientModule, GridModule],
    selector: 'cms-blog-component-images',
    templateUrl: 'cms-blog-component-images.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsBlogComponentImagesComponent extends UiComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: IPageComponentImagesData;
}
